__turbopack_context__.v({
  "commitmentsItem": "ResponsiveMenu-module__LeDWSq__commitmentsItem",
  "container": "ResponsiveMenu-module__LeDWSq__container",
  "destinationsItem": "ResponsiveMenu-module__LeDWSq__destinationsItem",
  "dropdownContainer": "ResponsiveMenu-module__LeDWSq__dropdownContainer",
  "helpCenterItem": "ResponsiveMenu-module__LeDWSq__helpCenterItem",
  "hiddenMobile": "ResponsiveMenu-module__LeDWSq__hiddenMobile",
  "hubDestinationItem": "ResponsiveMenu-module__LeDWSq__hubDestinationItem",
  "logo": "ResponsiveMenu-module__LeDWSq__logo",
  "logoBlock": "ResponsiveMenu-module__LeDWSq__logoBlock",
  "logoLink": "ResponsiveMenu-module__LeDWSq__logoLink",
  "nav": "ResponsiveMenu-module__LeDWSq__nav",
  "navNoMenu": "ResponsiveMenu-module__LeDWSq__navNoMenu",
  "previewModeText": "ResponsiveMenu-module__LeDWSq__previewModeText",
  "searchTrigger": "ResponsiveMenu-module__LeDWSq__searchTrigger",
  "transparent": "ResponsiveMenu-module__LeDWSq__transparent",
  "userAccountItem": "ResponsiveMenu-module__LeDWSq__userAccountItem",
  "whereToGoItem": "ResponsiveMenu-module__LeDWSq__whereToGoItem",
});
